import { createI18n } from 'vue-i18n';

export default createI18n({
  legacy: true,  // コンポーネントの $t (Options API) を有効化
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'ja',
  messages: {
    ja: require('@/locales/ja.json'),
  },
});
